import { formatTimelineTime, isCaptureFirstDateOnlyEntry, toTimelineDate } from './timelineDateUtils';

const getTimePeriod = (entry) => {
  if (isCaptureFirstDateOnlyEntry(entry)) {
    return null;
  }

  const hour = toTimelineDate(entry?.timestamp || entry).getHours();
  if (hour >= 6 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  return 'evening';
};

export const buildTimelineSummary = (entries = []) => ({
  totalEntries: entries.length,
  incidentCount: entries.filter((entry) => entry?.type === 'incident' || entry?.incidentStyle).length,
  dailyLogCount: entries.filter((entry) => entry?.collection === 'dailyLogs').length,
  dailyHabitCount: entries.filter((entry) => entry?.type === 'dailyHabit').length,
  therapyNoteCount: entries.filter((entry) => entry?.type === 'therapyNote').length,
  lastActivityTime: entries.length > 0 ? formatTimelineTime(entries[0]) : null,
  byTimePeriod: {
    morning: {
      hasIncidents: entries.some((entry) => (entry?.type === 'incident' || entry?.incidentStyle) && getTimePeriod(entry) === 'morning'),
      hasDailyLogEntries: entries.some((entry) => entry?.collection === 'dailyLogs' && getTimePeriod(entry) === 'morning'),
    },
    afternoon: {
      hasIncidents: entries.some((entry) => (entry?.type === 'incident' || entry?.incidentStyle) && getTimePeriod(entry) === 'afternoon'),
      hasDailyLogEntries: entries.some((entry) => entry?.collection === 'dailyLogs' && getTimePeriod(entry) === 'afternoon'),
    },
    evening: {
      hasIncidents: entries.some((entry) => (entry?.type === 'incident' || entry?.incidentStyle) && getTimePeriod(entry) === 'evening'),
      hasDailyLogEntries: entries.some((entry) => entry?.collection === 'dailyLogs' && getTimePeriod(entry) === 'evening'),
    },
  },
});
